var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-bar"},[_c('img',{staticClass:"logo",attrs:{"src":require("./../assets/logo.svg")}}),_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('addNew')}}},[_vm._v("Add New")])])}
var staticRenderFns = []

export { render, staticRenderFns }